import { createContext, useContext } from "react";

interface IContext {
  ControlProps?: {
    disabled: boolean;
  };

  openAuthorAutocomplete: boolean;
  onOpenAuthorAutocomplete: () => void;
  onCloseAuthorAutocomplete: () => void;
  // Types
  types: string[];
  setTypes: (types:string[]) => void;
};

export const Context = createContext<IContext | undefined>(undefined);

const useAuthorTypeGroupContext = ():IContext => {
  const context = useContext(Context);
  if ( !context ) throw new Error('useAuthorTypeGroupContext must be used within a AuthorTypeGroupProvider');
  return context;
};

export default useAuthorTypeGroupContext;
